import { render, staticRenderFns } from "./parkCarBox.vue?vue&type=template&id=b4d816ce&scoped=true"
import script from "./parkCarBox.vue?vue&type=script&lang=js"
export * from "./parkCarBox.vue?vue&type=script&lang=js"
import style0 from "./parkCarBox.vue?vue&type=style&index=0&id=b4d816ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4d816ce",
  null
  
)

export default component.exports